import type { ModuleManifest } from "./types";

export const projectTasksManifest: ModuleManifest = {
  name: "project-tasks",
  label: "Task",
  labelPlural: "Tasks",

  coreBOSModule: "ProjectTask",
  wsidPrefix: "51x",

  type: "standard",

  routes: {
    list: "/project-tasks",
    show: "/project-tasks/show/:id",
    create: "/project-tasks/create",
    edit: "/project-tasks/edit/:id",
  },

  navigation: {
    icon: "CheckSquareOutlined",
    order: 16,
    group: "Projects",
    hidden: true, // Accessed via Task Board panel, not direct navigation
  },

  routing: {
    keywords: [
      "task",
      "tasks",
      "todo",
      "todos",
      "action",
      "actions",
      "item",
      "items",
    ],
    searchFields: ["projecttaskname"],
    defaultSort: { field: "projecttaskpriority", order: "asc" },
  },

  context: {
    supported: true,
    entityKey: "project-tasks",
  },

  fields: [
    {
      name: "projecttaskname",
      label: "Task Name",
      type: "string",
      required: true,
    },
    {
      name: "projectid",
      label: "Project",
      type: "reference",
      referenceModule: "Project",
      required: true,
    },
    {
      name: "projecttaskpriority",
      label: "Priority",
      type: "picklist",
      options: [
        { value: "now", label: "Now" },
        { value: "tomorrow", label: "Tomorrow" },
        { value: "this_week", label: "This Week" },
        { value: "next_week", label: "Next Week+" },
        { value: "someday", label: "Someday" },
      ],
    },
    {
      name: "projecttaskstatus",
      label: "Status",
      type: "picklist",
      options: [
        { value: "Open", label: "Open" },
        { value: "In Progress", label: "In Progress" },
        { value: "Completed", label: "Completed" },
        { value: "Pending Input", label: "Pending Input" },
        { value: "Deferred", label: "Deferred" },
        { value: "Waiting", label: "Waiting" },
      ],
    },
    { name: "projecttaskprogress", label: "Progress", type: "number" },
    { name: "projecttaskhours", label: "Hours", type: "number" },
    { name: "startdate", label: "Start Date", type: "date" },
    { name: "enddate", label: "Due Date", type: "date" },
    {
      name: "projecttasktype",
      label: "Type",
      type: "picklist",
      options: [
        { value: "administrative", label: "Administrative" },
        { value: "operative", label: "Operative" },
        { value: "other", label: "Other" },
      ],
    },
    {
      name: "context",
      label: "Context",
      type: "string",
      // GTD contexts: @phone, @email, @computer, @meeting, @office, @home
    },
    { name: "description", label: "Description", type: "text" },
    {
      name: "assigned_user_id",
      label: "Assigned To",
      type: "reference",
      referenceModule: "Users",
      hidden: true,
      defaultValue: "19x1",
    },
  ],

  relationships: [
    {
      module: "Project",
      field: "projectid",
      // Note: parent relationship (many-to-one from task perspective)
      label: "Project",
      icon: "ProjectOutlined",
      displayField: "projectname",
    },
    {
      module: "Documents",
      relation: "many-to-many",
      label: "Documents",
      icon: "FolderOutlined",
      displayField: "notes_title",
    },
  ],

  requiredFields: ["projecttaskname", "projectid", "assigned_user_id"],

  massEdit: {
    enabled: true,
  },
};
